import axios, { AxiosError } from "axios";
import { SubscriptionDTO } from "../Models/DTOs/Subscription";

const BACKEND_URL = process.env.REACT_APP_WEB_API_URL ?? "/";

/**
 * GET /v1/users/{userId}/subscription
 * Returns the user's current subscription or null if none exists (404).
 * Requires Authorization: Bearer — the caller must be the user themselves or an admin.
 */
export async function GetUserSubscription(
    userId: string,
    accessToken: string,
    abortController: AbortController
): Promise<SubscriptionDTO | null | AxiosError> {
    try {
        const url = `${BACKEND_URL}v1/users/${encodeURIComponent(userId)}/subscription`;

        const res = await axios.get<SubscriptionDTO | { subscription: SubscriptionDTO }>(url, {
            signal: abortController.signal,
            timeout: 15000,
            headers: {Authorization: "Bearer " + accessToken},
        });

        // Accept either a raw object or { subscription: ... }
        const data =
            (res.data as any)?.subscription !== undefined
                ? (res.data as { subscription: SubscriptionDTO }).subscription
                : (res.data as SubscriptionDTO);

        return data ?? null;
    } catch (err: unknown) {
        if (axios.isAxiosError(err)) {
            if (err.response?.status === 404) return null; // "no subscription" case
            return err;
        }
        return new AxiosError("Non-Axios error", "ERR_UNKNOWN");
    }
}
